<div class="flex column justify-center ma" [ngClass]="sessionSrv.responsive ? 'w-70' : 'w-35'">
  <input #dni type="file" id="dni" name="file" class="input-img" accept="image/*,.pdf,.xml;base64"
    (change)="onselectDoc($event)" (click)="dni.value=''"/>
  <label for="dni" class="mb-2 commonButton primario blue flex align-center justify-center padding">{{'asistente.selectImage' | translate}}</label>
  <mm-button [cssClass]="'primario blue'" (notifyClick)="abrirWebcam()" *ngIf="!asistenteOcrSrv.checkNavigator()"
    [disabledButton]="!asistenteOcrSrv.hasWebcam" [label]="'asistente.webcam'"></mm-button>
</div>
